import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ControlContainer, FormGroupDirective, ReactiveFormsModule } from '@angular/forms';
import { TableModule } from 'primeng/table';
import { Button } from 'primeng/button';
import { MedicoPeriodoResponse } from '@/core/api/sicom-api/registro/medico/medico.model';

@Component({
    selector: 'app-suspensao',
    standalone: true,
    imports: [CommonModule, ReactiveFormsModule, TableModule, Button],
    templateUrl: './suspensao.html',
    viewProviders: [{ provide: ControlContainer, useExisting: FormGroupDirective }],
    changeDetection: ChangeDetectionStrategy.OnPush
})
/** Seção (tabela) de períodos de suspensão do médico. */
export class SuspensaoComponent {
    modoEdicao = input<boolean>(false);
    mostrarAreaSuspensao = input<boolean>(false);
    suspensoes = input<MedicoPeriodoResponse[]>([]);
    loadingSuspensoes = input<boolean>(false);
    erroSuspensoes = input<string | undefined>();
    baixarAnexo = output<MedicoPeriodoResponse>();
}
